import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {QbReceivePaymentDetailDto} from "../../model/QbReceivePaymentDetailDto";
import {DisposeBag} from "../../modules/DisposeBag";
import {ConfigService} from "../../modules/ConfigModule";

export default class ViewController implements Ng1Controller {
    private error: any;
    private payment: QbReceivePaymentDetailDto;
    private disposeBag = new DisposeBag();

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any,
                private $config: ConfigService) {
        $dataHub.onPaymentDetailUpdated(e => this.payment = e, this.disposeBag);

        $dataHub.onConnected(this.refresh, this.disposeBag);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.paymentDetailSubscribeAndQuery(this.$stateParams.paymentGuid)
            .then(ret => this.payment = ret)
            .catch(e => this.error = e);
    };

    get showDiscount() {
        return this.payment?.appliedToTxns?.some(a=>a.discountAmount);
    }

}
